import ShapeUploader from './ShapeUploader';

export default ShapeUploader;